// extracted by mini-css-extract-plugin
export default {"root":"AppBasicButton_root__dRJNW"};